<template>
  <div class="collapsible">
      <input type="checkbox" :id="id" class="collapsible-toggle">
      <label :for="id" class="collapsible-label" @click="toggleFullscreen">
        <div style="width: 90%;">
          <div v-if="title">{{ title }}</div>
          <div v-else>
            <slot name="title"></slot>
          </div>
        </div>
      </label>
      <div class="collapsible-content" ref="collapsibleContent">
          <div class="collapsible-text">
             <div v-if="text"></div>
             <slot name="content"></slot>
          </div>
      </div>
  </div>
</template>
<script >
import { ref } from '@nuxtjs/composition-api';
export default {
  props: {
    title: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'collapsible-1'
    }
  },
  setup() {
    const show = ref(false);
    const collapsibleContent = ref(null);
    const toggleFullscreen = (event) => {
      // 防连点
      if (event) {
        event.stopPropagation();
      }
      show.value = !show.value;
      if (show.value) {
        collapsibleContent.value.style.maxHeight = '1000px';
        // 加上滚动
        collapsibleContent.value.style.overflow = 'auto';
      } else {
        collapsibleContent.value.style.maxHeight = '0';
      }
    };
    return {
      show,
      toggleFullscreen,
      collapsibleContent
    };
  }
};
</script>
<style scoped>
.collapsible {
  background-color: #f1f1f1;
  border-radius: 4px;
  margin-bottom: 10px;
}

.collapsible-toggle {
  display: none;
}

.collapsible-label {
  display: block;
  padding: 10px 15px;
  background-color: #e0e0e0;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  position: relative;
}

.collapsible-label:hover {
  background-color: #d0d0d0;
}

.collapsible-label::after {
    content: '';
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPjxwb2x5bGluZSBwb2ludHM9IjYgOSAxMiAxNSAxOCA5Ij48L3BvbHlsaW5lPjwvc3ZnPg==');
    background-size: contain;
    background-repeat: no-repeat;
    width: 24px;
    height: 24px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%) rotate(-90deg);
    transition: transform 0s ease;
}
.collapsible-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0s ease;
}

.collapsible-toggle:checked + .collapsible-label::after {
  transform: rotate(0);
  top: 20%;
}

/* .collapsible-toggle:checked ~ .collapsible-content {
  max-height: 1000px;
}
*/

.collapsible-text {
  padding: 15px;
}
</style>
